//#region src/utils/buttonEffect.ts
var e = (e, t = null) => {
	let n = t || e.currentTarget, r = n.getBoundingClientRect(), i = document.createElement("span"), a = Math.max(n.clientWidth, n.clientHeight), o = a / 2;
	if (i.style.width = i.style.height = `${a}px`, e instanceof MouseEvent && (i.style.left = `${e.clientX - r.left - o}px`, i.style.top = `${e.clientY - r.top - o}px`), window.TouchEvent && e instanceof window.TouchEvent) {
		let t = e.touches[0];
		i.style.left = `${t.clientX - r.left - o}px`, i.style.top = `${t.clientY - r.top - o}px`;
	}
	i.classList.add("btn-ripple");
	let s = n.getElementsByClassName("btn-ripple")[0];
	s && s.remove(), n.appendChild(i), setTimeout(() => i.remove(), 1e3);
}, t = (e) => {
	if (!e || !e.className) return !1;
	let { className: t = "" } = e;
	if (typeof t != "string") return !1;
	let n = t.includes("btn "), r = !t.includes("btn-component"), i = !t.includes("btn-link"), a = !t.includes("close"), o = !t.includes("btn-action"), s = !t.includes("disabled");
	return n && r && s && i && a && o;
}, n = (n) => {
	let r = n.target;
	if (r) {
		let i = t(r), a = !i && t(r.parentElement);
		(i || a) && e(n, a ? r.parentElement : r);
	}
};
((e) => {
	e && (e.addEventListener("mousedown", n, !1), e.addEventListener("touchstart", n, !1));
})(document);
//#endregion
export { e as createButtonRipple };

//# sourceMappingURL=buttonEffect.js.map